/** Authentication Form Fields**/
export const AUTH_PAYMENT_TYPE = 'paymentType';
export const AUTH_BILLING_ADDRESS = 'billingAddress';
export const AUTH_CARD_NUMBER = 'cardNumber';
export const AUTH_CITY = 'city';
export const AUTH_CVV = 'CVV';
export const AUTH_EXPIRATION_DATE = 'expirationDate';
export const AUTH_COUNTRY = 'country';
export const AUTH_ZIPCODE = 'zipCode';
export const AUTH_PIN = 'pin';
export const AUTH_SERVICE_CODE = 'serviceCode';

/** Merchant Form Fields**/
export const MERCH_PLATFORM_NAME = 'platformName';
export const MERCH_ADDRESS = 'merchantAddress';
export const MERCH_CITY = 'merchantCity';
export const MERCH_STATE = 'merchantState';
export const MERCH_COUNTRY = 'merchantCountry';

/** Transactions Form Fields**/
export const TRANS_CURRENCY = 'transactionCurrency';
export const TRANS_AMOUNT = 'transactionAmount';
export const TRANS_ID = 'transactionID';
export const TRANS_TYPE = 'transactionType';
export const TRANS_CONVERSION_RATE = 'conversionRate';
export const TRANS_MCC = 'mcc';
export const TRANS_RECURRING = 'recurring';

/** Meta Form Fields **/
export const META_PARTIAL_APPROVAL = 'partialApproval';
export const META_LIFECYCLE_INT = 'lifeCycleInt';
export const META_LIFECYCLE = 'lifeCycle';
export const META_NETWORK_ID = 'networkID';
export const META_TERMINAL_ID = 'terminalID';
export const META_RECURRING = 'recurring';
export const META_CONDITION = 'conditionCode';
export const META_PAN_ENTRY = 'panEntry';
export const META_PIN_ENTRY = 'pinEntry';
export const META_CARD_PRES = 'cardPresence';
export const META_ACCT_PRES = 'acctPresence';
export const META_SECU_CON = 'securityConcern';
export const META_PRES_TYPE = 'presentmentType';
export const META_TERMINAL_TYPE = 'terminalType';
export const META_TERMINAL_LOC = 'terminalLocation';
export const META_TERMINAL_OP = 'terminalOperatior';
export const META_TERMINAL_ATT = 'terminalAttendance';
export const META_CARD_INPUT = 'cardInput';
export const META_CARD_RETENTION = 'cardRetention';
export const META_FORCE_POST = 'forcePost';